module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Maltings-Antiqua.4f039bf9.jpg";